import Field from "@/components/Field";
import ProjectSelect from "@/components/ProjectSelect";
import { isRequired } from "@/lib/form";
import ProjectRoleSelect from "@/modules/projects/components/ProjectRoleSelect";
import ProjectStoreSelect from "@/modules/projects/components/ProjectStoreSelect";
import { PROJECT_DEPENDENCY_ROLE } from "@/schemas/commonFields/projectDependsOn";
import { writeRoleBasedAssignments } from "@/schemas/roleBasedAssignments";
import { useTranslation } from "react-i18next";

const schema = writeRoleBasedAssignments;

interface ContractorsAssignmentsRoleBasedFieldsProps {
  selectedProjectId: string | undefined;
  onProjectChangeWithReset: (projectId: string) => void;
}

export const ContractorsAssignmentsRoleBasedFields = ({
  selectedProjectId,
  onProjectChangeWithReset,
}: ContractorsAssignmentsRoleBasedFieldsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Field
        name="project_id"
        label={t("contractorsAssignments.fields.project_id")}
        required
        render={({ field }) => (
          <ProjectSelect
            {...field}
            className="w-80"
            loading="eager"
            value={selectedProjectId || ""}
            inDialog
            projectDependsOn={PROJECT_DEPENDENCY_ROLE}
            onChange={(value) => {
              onProjectChangeWithReset(value);
            }}
          />
        )}
      />
      <Field
        name="store_id"
        label={t("contractorsAssignments.fields.store_id")}
        required={isRequired(schema.shape.store_id)}
        render={({ field }) => (
          <ProjectStoreSelect
            {...field}
            key={selectedProjectId}
            className="w-80"
            projectId={selectedProjectId || ""}
            loading="eager"
            loadingCondition={Boolean(selectedProjectId)}
            inDialog
            disabled={!selectedProjectId}
          />
        )}
      />
      <Field
        name="project_role_id"
        label={t("contractorsAssignments.fields.project_role_id")}
        required={
          "project_role_id" in schema.shape &&
          isRequired(schema.shape.project_role_id)
        }
        render={({ field }) => (
          <ProjectRoleSelect
            {...field}
            key={selectedProjectId}
            className="w-80"
            projectId={selectedProjectId || ""}
            loading="eager"
            loadingCondition={Boolean(selectedProjectId)}
            inDialog
            disabled={!selectedProjectId}
          />
        )}
      />
    </>
  );
};
